const chatButtons = document.querySelectorAll('[data-toggle-chat-popup]');

chatButtons.forEach(button => {
  button.addEventListener('click', () => {
    const wrapper = document.querySelector('#ShopifyChat');
    const trigger = wrapper.shadowRoot.querySelector('.chat-toggle, .chat-app--close-button');

    trigger.click();
  });
});